<template>
  <div style="height: 100%; background: white; padding: 10px">
    <Tabs v-model="tab" @on-click="tabChange">
      <TabPane
        v-for="item in tabs"
        :label="item.label"
        :name="item.value"
        :key="item.value"
      >
        <timeliness
          v-if="item.timeliness"
          style="height: calc(100vh - 200px)"
          :data="tabsData[item.value]"
          :headers="header"
          :name="item.value"
          :ref="item.value"
        ></timeliness>
        <component
          v-else
          style="height: calc(100vh - 200px)"
          :data="tabsData[item.value]"
          :type="item.value"
          :headers="header"
          :name="item.value"
          :ref="item.value"
          :noPage="item.noPage"
          :is="item.value"
        ></component>
      </TabPane>
    </Tabs>
  </div>
</template>

<script>
import abnormal from "./abnormal";
import timeliness from "./timeliness";

import { apis } from "@/api/analysis/timeoutOrderStatistics";
import { optionsApi, optionsCommonApi } from "@/libs/api.request.js";

export default {
  name: "timeoutOrderStatistics",
  components: {
    abnormal,
    timeliness
  },
  mounted() {
    optionsCommonApi(
      this.header.reduce((a, b) => {
        if (b.options && !b.options.length) {
          b.optionsKey && a.set(b, b.optionsKey);
          b.optionsFn && optionsApi(b, b.optionsFn);
        }
        return a;
      }, new Map())
    );
    setTimeout(() => {
      this.tabChange(this.tab);
    }, 100);
  },
  methods: {
    tabChange(e) {
      if (this.$refs[e][0].init) return;
      this.$refs[e][0].init = true;
      this.$refs[e][0].$refs.table.getList();
    }
  },
  data() {
    return {
      tab: "abnormal",
      tabs: [
        {
          label: this.$tz("异常率"),
          value: "abnormal"
        },
        {
          label: this.$tz("及时率,（,仓库,）"),
          timeliness: true,
          value: "delivery"
        },
        {
          label: this.$tz("及时率,（,客服,）"),
          timeliness: true,
          value: "service"
        }
      ],
      tabsData: {
        delivery: {
          list: apis.delivery
        },
        service: {
          list: apis.service
        },
        abnormal: {
          list: apis.abnormal
        }
      },
      header: [
        {
          key: "dateType",
          placeholder() {
            return this.$tz("日期,类型");
          },
          component: "Select",
          options: [],
          optionsFn: "",
          optionsKey: "TIMEOUT_ORDER_SELECT",
          noAuto: true
        },
        {
          key: "startTime",
          placeholder() {
            return this.$tz("请选择,开始,日期");
          },
          component: "DatePicker",
          bind: {
            options: {
              disabledDate(time) {
                return time.getTime() > Date.now();
              }
            },
            style: {
              width: "150px"
            }
          },
          default: new Date(
            new Date(new Date().setDate(1)).setHours(0, 0, 0, 0)
          )
        },
        {
          key: "endTime",
          placeholder() {
            return this.$tz("请选择,结束,日期");
          },
          component: "DatePicker",
          bind: {
            options: {
              disabledDate(time) {
                return time.getTime() > Date.now();
              }
            },
            style: {
              width: "150px"
            }
          },
          default: new Date(new Date().setHours(23, 59, 59, 59)),
          noAuto: true
        },
        {
          key: "client_id",
          placeholder() {
            return this.$tz("客户名称");
          },
          component: "Select",
          options: [],
          optionsFn: "getAllClient",
          optionsKey: "",
          noAuto: true
        },
        {
          key: "delivery_agent",
          placeholder() {
            return this.$tz("地派");
          },
          component: "Select",
          options: [],
          optionsFn: "agent",
          optionsKey: "",
          noAuto: true
        },
        {
          key: "from_country",
          placeholder() {
            return this.$tz("起运国家");
          },
          component: "Select",
          options: [],
          optionsFn: "formCountry",
          optionsKey: "",
          noAuto: true
        },
        {
          key: "to_country",
          placeholder() {
            return this.$tz("目的国家");
          },
          component: "Select",
          options: [],
          optionsFn: "toCountry",
          optionsKey: "",
          noAuto: true
        },
        {
          key: "customer_service",
          placeholder() {
            return this.$tz("客服");
          },
          component: "Select",
          options: [],
          optionsFn: "service",
          optionsKey: "",
          apiData: [1],
          noAuto: true
        },
        {
          key: "status",
          placeholder() {
            return this.$tz("处理状态");
          },
          component: "Select",
          options: [
            {
              label: this.$tz("未处理"),
              value: 1
            },
            {
              label: this.$tz("已处理"),
              value: 2
            }
          ],
          optionsFn: "",
          optionsKey: "",
          noAuto: true
        }
      ]
    };
  }
};
</script>

<style></style>
